var map = {
	"./0001.png": 973,
	"./0002.png": 974,
	"./0003.png": 975,
	"./0004.png": 976,
	"./0005.png": 977,
	"./0006.png": 978,
	"./0007.png": 979,
	"./0008.png": 980,
	"./0009.png": 981,
	"./0010.png": 982,
	"./0011.png": 983,
	"./0012.png": 984,
	"./0013.png": 985,
	"./0014.png": 986,
	"./0015.png": 987,
	"./0016.png": 988,
	"./0017.png": 989,
	"./0018.png": 990,
	"./0019.png": 991,
	"./0020.png": 992,
	"./0021.png": 993,
	"./0022.png": 994,
	"./0023.png": 995,
	"./0024.png": 996,
	"./0025.png": 997,
	"./0026.png": 998,
	"./0027.png": 999,
	"./0028.png": 1000,
	"./0029.png": 1001,
	"./0030.png": 1002,
	"./0031.png": 1003,
	"./0032.png": 1004,
	"./0033.png": 1005,
	"./0034.png": 1006,
	"./0035.png": 1007,
	"./0036.png": 1008,
	"./0037.png": 1009,
	"./0038.png": 1010,
	"./0039.png": 1011,
	"./0040.png": 1012,
	"./0041.png": 1013,
	"./0042.png": 1014,
	"./0043.png": 1015,
	"./0044.png": 1016,
	"./0045.png": 1017,
	"./0046.png": 1018,
	"./0047.png": 1019,
	"./0048.png": 1020,
	"./0049.png": 1021,
	"./0050.png": 1022
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 972;